import { Button } from '@material-ui/core';
import { getMerchantById, MerchantStatus } from '@nemuru-eng/js-api-client';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Font } from '@/components/shared/components/Font';
import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { MerchantDetailDialog } from '@/components/widgets/MerchantDetailActions/components/MerchantDetailDialog';
import { MerchantDetailAction } from '@/components/widgets/MerchantDetailActions/types/MerchantDetailAction';
import { useCache } from '@/hooks/requests/useCache';

export const MerchantDetailActions = () => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: merchant } = useCache(getMerchantById, { merchantId });

  const [currentAction, setCurrentAction] = useState<MerchantDetailAction | undefined>();

  const { opened, setOpened, toggleDialog } = useDialog();

  const toggleActionDialog = (actionType: MerchantDetailAction) => {
    setCurrentAction(actionType);
    toggleDialog();
  };

  let actions: ActionsOption[] = [];

  if (!merchant?.approvalStatus.isApprovedByCommercial)
    actions.push({
      display: <Text tId={'APPROVE_BY_COMMERCIAL'} />,
      onClick: () => toggleActionDialog(MerchantDetailAction.APPROVE_BY_COMMERCIAL),
      iconName: 'assignment_turned_in',
    });

  if (!merchant?.approvalStatus.isApprovedByRisk)
    actions.push({
      display: <Text tId={'APPROVE_BY_RISK'} />,
      onClick: () => toggleActionDialog(MerchantDetailAction.APPROVE_BY_RISK),
      iconName: 'assignment_turned_in',
    });

  actions = [
    ...actions,
    ...[
      {
        display: <Text tId={'SUSPEND_ACTION'} />,
        onClick: () => toggleActionDialog(MerchantDetailAction.SUSPEND_ACTION),
        iconName: 'gpp_bad',
        disabled: merchant?.status === MerchantStatus.STATUS_SUSPENDED,
      },
      {
        display: <Text tId={'BAN_ACTION'} />,
        onClick: () => toggleActionDialog(MerchantDetailAction.BAN_ACTION),
        iconName: 'delete_forever',
        disabled: merchant?.status === MerchantStatus.STATUS_BANNED,
      },
      ...(merchant?.status === MerchantStatus.STATUS_BANNED || merchant?.status === MerchantStatus.STATUS_SUSPENDED
        ? [
            {
              display: <Text tId={'REACTIVATE_ACTION'} />,
              onClick: () => toggleActionDialog(MerchantDetailAction.REACTIVATE_ACTION),
              iconName: 'key',
            },
          ]
        : []),
    ],
  ];

  return (
    <>
      <MoreActionsMenu actionsOptionsArray={actions}>
        <Button>
          <Font variant={'subtitle2'} color={'textSecondary'}>
            <i
              className={'material-icons-outlined mr-2'}
              style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
            >
              menu
            </i>
            <Text tId={'ACTIONS'} />
          </Font>
        </Button>
      </MoreActionsMenu>
      {currentAction && merchant && (
        <MerchantDetailDialog
          currentAction={currentAction}
          merchant={merchant}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
        />
      )}
    </>
  );
};
